export interface ISpotifyData {
    id: string,
    type: string,
}

export function instanceOfSpotifyData(data: any): boolean {
    return 'id' in data && 'type' in data;
}
